import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { StarIcon } from 'lucide-react';
export function FeaturedTestimonial() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-2076">
      <div className="max-w-[900px] mx-auto px-6 lg:px-8" data-id="element-2077">
        <AnimateOnScroll className="text-center" data-id="element-2078">
          {/* Large Quote Mark */}
          <div className="text-[#FF1493] text-[80px] lg:text-[100px] leading-none font-serif mb-4 select-none" data-id="element-2079">
            &ldquo;
          </div>

          {/* Testimonial Text */}
          <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.7] mb-8 max-w-[800px] mx-auto" data-id="element-2080">
            5-stars across the board! I have done a handful of treatments here
            and am always blown away with the outcome. These nurses are so
            professional and they take the time to make you feel comfortable,
            educated and excited for each and every treatment. Thank you Be
            CLINICAL for everything you do!
          </p>

          {/* Stars */}
          <div className="flex gap-1 justify-center mb-4" data-id="element-2081">
            {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2082" />)}
          </div>

          {/* Attribution */}
          <p className="text-[#666666] text-sm uppercase tracking-widest font-[Poppins,_sans-serif]" data-id="element-2083">
            — Verified Patient
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}